import { render, staticRenderFns } from "./AtendimentosRealizados.vue?vue&type=template&id=0a9d2a13"
import script from "./AtendimentosRealizados.vue?vue&type=script&lang=js"
export * from "./AtendimentosRealizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports